import Vue from 'vue'
// import VueI18n from 'vue-i18n'
import Cookies from 'vue-cookies'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
// import elementTcLocale from 'element-ui/lib/locale/lang/zh-TW'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementJaLocale from 'element-ui/lib/locale/lang/ja'
import elementViLocale from 'element-ui/lib/locale/lang/vi'
import elementKoLocale from 'element-ui/lib/locale/lang/ko'
import elementThLocale from 'element-ui/lib/locale/lang/th'
import elementIdLocale from 'element-ui/lib/locale/lang/id'
import elementArLocale from 'element-ui/lib/locale/lang/ar'
import elementESECLocale from 'element-ui/lib/locale/lang/es'
import elementDELocale from 'element-ui/lib/locale/lang/de'
import elementFRLocale from 'element-ui/lib/locale/lang/fr'

const locales = [
  { code: 'en', file: 'en.json', element: elementEnLocale },
  // { code: 'tc', file: 'zh-tw.json', element: elementTcLocale },
  { code: 'zh', file: 'zh.json', element: elementZhLocale },
  { code: 'zh-Hant', file: 'zh.json', element: elementZhLocale },
  { code: 'ja', file: 'ja.json', element: elementJaLocale },
  { code: 'vi', file: 'vi.json', element: elementViLocale },
  { code: 'ko', file: 'ko.json', element: elementKoLocale },
  { code: 'th', file: 'th.json', element: elementThLocale },
  { code: 'id', file: 'id.json', element: elementIdLocale },
  { code: 'ar', file: 'ar.json', element: elementArLocale },
  { code: 'es', file: 'es-EC.json', element: elementESECLocale },
  { code: 'lo', file: 'lo.json' },
  { code: 'de', file: 'de.json', element: elementDELocale },
  { code: 'fr', file: 'fr.json', element: elementFRLocale }
]

const i18n = {
  t: (val) => {
    return val
  }
}

export async function initTolgee(languageList = null) {
  // Determine the language to use
  let lang = getLanguage(languageList)

  // tolgee 繁体默认语言是 zh-Hant 西班牙语是 es-EC
  // 这里需要转换一下
  switch (lang) {
    case 'tc':
      lang = 'zh-Hant'
      break
    case 'es':
      lang = 'es-EC'
      break
  }

  // Reinitialize Tolgee with the correct language
  const { Tolgee, InContextTools, FormatSimple, BackendFetch } = window['@tolgee/web']
  const tolgee = Tolgee().use(InContextTools()).use(FormatSimple()).use(BackendFetch()).init({
    defaultLanguage: lang,
    apiUrl: 'https://tolgee.voov.cc',
    // apiKey: 'tgpak_gfpwsmbxhfrte5rtnvvxe5twnjsge5lunqyg2oddhfswe'
    apiKey: 'tgpak_gjpxeyjygvygw2rrg42tq2lkmm4ws2dtgjxto3logjsgo'
    // 静态默认语言
  })
  tolgee.addStaticData({
    [lang]: {
      'common.aboutUs': '关于我们'
    }
  })

  // First load static translations - this will be our fallback source
  const localeConfig = locales.find((l) => l.code === lang) || locales.find((l) => l.code === 'en')
  let localTranslations = {}

  try {
    // Load the local translations first
    const { file, element = {} } = localeConfig
    const langModule = await import(/* webpackChunkName: "lang-[request]" */ `./${file}`).catch((err) => {
      console.warn(`Import failed for ${file}: ${err.message}`)
      return { default: {} }
    })

    localTranslations = {
      ...(langModule.default || langModule),
      ...element
    }

    // Add local translations as static data (fallback)
    tolgee.addStaticData({
      [lang]: localTranslations
    })
  } catch (err) {
    console.error('Failed to load local translations:', err)
  }

  try {
    const TIMEOUT = 3000
    await Promise.race([
      tolgee.run(),
      new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Tolgee initialization timed out')), TIMEOUT)
      })
    ])
  } catch (err) {
    console.warn('Failed to load remote translations, using static only:', err)
  }

  // key and tolgeeTranslation may not equal because there are some invisible characters
  function stripInvisibleChars(str) {
    return str.replace(/[\u200B-\u200D\uFEFF\u2060]/g, '')
  }

  function getNestedValue(obj, path) {
    const keys = path.split('.')
    let result = obj

    for (const key of keys) {
      if (result === undefined || result === null) {
        return undefined
      }
      result = result[key]
    }

    return result
  }

  // 替换方法
  const formatString = (template, values) => {
    return template.replace(/\{(\d+)\}/g, (match, index) => (values[index] !== undefined ? values[index] : match))
  }

  const translationWithFallback = (key, params) => {
    // First try to get the translation from Tolgee (which attempts remote first)
    const tolgeeTranslation = tolgee.t(key, params)

    // If Tolgee returns the key, it means translation wasn't found
    // Try to get from our local translations instead
    if (stripInvisibleChars(key) === stripInvisibleChars(tolgeeTranslation)) {
      const localValue = getNestedValue(localTranslations, key)
      if (localValue) {
        // 如果有需要替换的值
        if (params && params.length > 0) {
          return formatString(localValue, params)
        }
        return localValue
      }
    }

    // Return what Tolgee provided (either translation or key)
    return tolgeeTranslation
  }

  // Mount to Vue prototype
  Vue.prototype.$t = translationWithFallback
  Vue.prototype.$i18n = {
    t: translationWithFallback
  }
  i18n.t = translationWithFallback

  return tolgee
}

export function getLanguage(languageList = null) {
  // get user choose language
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage

  // if language list is provided and has items, use the first one as default
  if (languageList && Array.isArray(languageList) && languageList.length > 0) {
    const firstLang = languageList[0]
    // Use 'value' property which is the frontend language code, fallback to 'code' if value doesn't exist
    const defaultLang = firstLang.value || firstLang.code || firstLang
    return defaultLang
  }

  // if no language list provided, try to get from cache (localStorage)
  if (!languageList) {
    try {
      const cachedLanguageList = localStorage.getItem('cached_language_list')
      if (cachedLanguageList) {
        const parsed = JSON.parse(cachedLanguageList)
        if (Array.isArray(parsed) && parsed.length > 0) {
          const firstLang = parsed[0]
          const defaultLang = firstLang.value || firstLang.code || firstLang
          return defaultLang
        }
      }
    } catch (error) {
      console.warn('Failed to parse cached language list:', error)
    }
  }

  // fallback to browser language detection (old logic)
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const availableLocales = locales.map((locale) => locale.code)
  for (const locale of availableLocales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

export function cacheLanguageList(languageList) {
  if (languageList && Array.isArray(languageList) && languageList.length > 0) {
    try {
      localStorage.setItem('cached_language_list', JSON.stringify(languageList))
    } catch (error) {
      console.error('Failed to cache language list:', error)
    }
  }
}

export default i18n
